import type { IPopupConfig } from "@similarweb/ui-components";
import type { TooltipConfigSettings } from "./types";

const TOOLTIP_WIDTH = 324;

const DEFAULT_TOOLTIP_CONFIG: IPopupConfig = {
    cssClass: "Popup-element-wrapper--pro",
    width: TOOLTIP_WIDTH,
    placement: "bottom",
};

const TOOLTIP_CONFIG_LEFT_PLACEMENT: IPopupConfig = {
    ...DEFAULT_TOOLTIP_CONFIG,
    placement: "left",
};

export const getTooltipConfig = ({ withLeftAlignment }: TooltipConfigSettings): IPopupConfig => {
    if (withLeftAlignment) {
        return TOOLTIP_CONFIG_LEFT_PLACEMENT;
    }

    return DEFAULT_TOOLTIP_CONFIG;
};

export const checkIsPopupBottomPlacement = (placement: IPopupConfig["placement"]): boolean => {
    return placement?.includes("bottom") ?? false;
};
